import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueUserFormJournal', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/housing_association_issue_list/journal/journal.html'),
        controller: 'IssueUserFormJournalController',
        controllerAs: 'IssueUserFormJournalCtrl',
        bindings: {
            itemId: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/journal/journal.component.ts